import { ChangeEvent, MouseEvent, useEffect, useState } from "react";
import ResetCommercialPasswordForm from "./components/ResetCommercialPasswordForm";
import {
  CommercialUserProps,
  ResetCommercialPasswordInput,
  ResetCommercialPasswordInputError,
  stateStatusType,
} from "../../state/actionType";
import { ValidateRsetPassowrdForm } from "./components/ValidateForm";
import { connect, useSelector } from "react-redux";
import { resetCommercialUserPassword } from "../../state/action";
import { ApiError } from "components";

interface OwnProps {
  onClose: () => void;
  commercialUserData: CommercialUserProps;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleResetCommercialPassword: React.FC<Props> = ({
  onClose,
  commercialUserData,
  onResetCommercialPassword,
}) => {
  const commercialUserState = useSelector(
    (state: any) => state.commercialUser.genericCommercialUserState
  );
  const [formData, setFormData] = useState<ResetCommercialPasswordInput>({
    user_id: commercialUserData.id.toString(),
    password: "",
    confirm_password: "",
  });
  const [error, setError] = useState<ResetCommercialPasswordInputError>({});
  const [apiError, setApiError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const handleSubmit = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setSubmitted(true);
    const validationErrors = ValidateRsetPassowrdForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setError(validationErrors);
      return;
    }
    setIsLoading(true);
    onResetCommercialPassword(
      formData.password,
      formData.confirm_password,
      commercialUserData.id.toString()
    );
    setIsLoading(false);
  };
  useEffect(() => {
    if (
      submitted &&
      commercialUserState.status === stateStatusType.SUCCESS &&
      commercialUserState.error === null
    ) {
      onClose(); // Close the modal
    } else {
      setApiError(commercialUserState.error);
    }
  }, [
    submitted,
    commercialUserState.status,
    commercialUserState.error,
    onClose,
  ]);
  return (
    <>
      <ResetCommercialPasswordForm
        header={"Update user password"}
        loading={isLoading}
        formData={formData}
        error={error}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        onClose={onClose}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onResetCommercialPassword: (
    password: string,
    confirm_password: string,
    user_id: string
  ) =>
    dispatch(resetCommercialUserPassword(password, confirm_password, user_id)),
});

export default connect(null, mapDispatchToProps)(HandleResetCommercialPassword);
